import React from 'react';
import { connect } from 'react-redux';
import * as transactions from '~/actions/transactions';
import { Button } from 'react-toolbox/lib/button';
import TimePicker from 'react-toolbox/lib/time_picker';
import Spinner from '~/components/Spinner';
import MultiPicker from '~/components/MultiPicker';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import LocationPicker from '~/components/LocationPicker';
import OrderPicker from '~/components/OrderPicker';
import UserPicker from '~/components/UserPicker';
import TaskPicker from '~/components/TaskPicker';
import ContainerPicker from '~/components/ContainerPicker';
import ArticlePicker from '~/components/ArticlePicker';
import RecipePicker from '~/components/RecipePicker';
import DatePicker from '~/components/DatePicker';

import Tag from '~/components/Tag';

import style from './style.scss';

const components = {
  rawMaterialIds: {
    label: 'Raw Material',
    component: MultiPicker(RawMaterialPicker),
    required: false
  },
  articleIds: {
    label: 'Article',
    component: MultiPicker(ArticlePicker),
    required: false
  },
  orderIds: {
    label: 'Order',
    component: MultiPicker(OrderPicker),
    required: false
  },
  locationIds: {
    label: 'Location',
    component: MultiPicker(LocationPicker),
    required: false
  },
  taskIds: {
    label: 'Task',
    component: MultiPicker(TaskPicker),
    required: false
  },
  containerIds: {
    label: 'Container',
    component: MultiPicker(ContainerPicker),
    required: false
  },
  userIds: {
    label: 'User',
    component: MultiPicker(UserPicker),
    required: false
  },
  recipeIds: {
    label: 'Recipes',
    component: MultiPicker(RecipePicker),
    required: false
  },
};

class Transactions extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      results: [],
      query: '',
      expanded: [],
      ids: {
        rawMaterialIds: [],
        articleIds: [],
        orderIds: [],
        locationIds: [],
        taskIds: [],
        containerIds: [],
        userIds: [],
        recipeIds: [],
        customerIds: [],
      }
    };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true, expanded: [] });
    transactions.list(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.ids,
      this.state.fromDate,
      this.state.toDate,
    )
      .then(r => {
        this.setState({
          results: r.data.results.map(i => i.id),
          skipId: r.data.skipId,
          more: r.data.more,
          loading: false,
        });
      });
  }

  loadMore() {
    this.setState({ loading: true });
    transactions.list(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.ids,
      this.state.fromDate,
      this.state.toDate,
      this.state.skipId,
    )
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results.map(i => i.id)],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }));
  }

  renderTransaction(id) {
    const transaction = this.props.items[id];
    if (!transaction) {
      return false;
    }
    const expanded = this.state.expanded.includes(id);
    return (
      <div key={id} className={style.row}>
        <div className={style.info}>
          <div className={style.date}>{new Date(transaction.created).toISOString().replace('T', ' ').replace('Z', '')}</div>
          <div className={style.type}>#{transaction.sku} - {transaction.type}</div>
        </div>
        <div className={style.tags}>
          {transaction.taskIds && transaction.taskIds.map((v, i) => <Tag key={v + i} type="task" id={v} />)}
          {transaction.recipeIds && transaction.recipeIds.map((v, i) => <Tag key={v + i} type="recipe" id={v} />)}
          {transaction.orderIds && transaction.orderIds.map((v, i) => <Tag key={v + i} type="order" id={v} />)}
          {transaction.containerIds && transaction.containerIds.map((v, i) => <Tag key={v + i} type="container" id={v} />)}
          {transaction.articleIds && transaction.articleIds.map((v, i) => <Tag key={v + i} type="article" id={v} />)}
          {transaction.locationIds && transaction.locationIds.map((v, i) => <Tag key={v + i} type="location" id={v} />)}
          {transaction.rawMaterialIds && transaction.rawMaterialIds.map((v, i) => <Tag key={v + i} type="rawMaterial" id={v} />)}
          {transaction.userIds && transaction.userIds.map((v, i) => <Tag key={v + i} type="user" id={v} />)}
          {transaction.customerIds && transaction.customerIds.map((v, i) => <Tag key={v + i} type="customer" id={v} />)}
        </div>
        <div className={style.more}>
          <Button
            label={expanded ? 'Show less' : 'Show more'}
            primary
            icon={expanded ? 'expand_less' : 'expand_more'}
            onClick={() => this.setState({
              expanded: expanded
                ? this.state.expanded.filter(i => i !== id)
                : [...this.state.expanded, id]
            })}
          />
        </div>
        {expanded && <div className={style.expanded}>
          <pre>{JSON.stringify(transaction.meta, undefined, 4)}</pre>
        </div>}
      </div>
    );
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <div className={style.title}>Transactions</div>
        <form onSubmit={e => { e.preventDefault(); this.setState({ skipId: null }); this.search(); }} style={{ marginBottom: '10px' }}>
          <input
            placeholder="Search Type, SKU, ID, Text"
            className={style.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <div className={style.filters}>
            <b>Filters</b>
            <div className={style.filter}>
              <div className={style.item} style={{ minWidth: '85px' }}>
                <DatePicker
                  label="From Date"
                  locale="us"
                  sundayFirstDayOfWeek
                  value={this.state.fromDate}
                  onChange={v => this.setState({ fromDate: v })}
                  onDismiss={() => this.setState({ fromDate: undefined })}
                />
                <TimePicker
                  label="From Time"
                  value={this.state.fromDate}
                  onChange={v => this.setState({ fromDate: v })}
                />
              </div>
            </div>
            <div className={style.filter}>
              <div className={style.item} style={{ minWidth: '85px' }}>
                <DatePicker
                  label="To Date"
                  locale="us"
                  sundayFirstDayOfWeek
                  value={this.state.toDate}
                  onChange={v => this.setState({ toDate: v })}
                  onDismiss={() => this.setState({ toDate: undefined })}
                />
                <TimePicker
                  label="To Time"
                  value={this.state.toDate}
                  onChange={v => this.setState({ toDate: v })}
                />
              </div>
            </div>
            {Object.keys(components).map(key => {
              const Cmp = components[key].component;
              const field = components[key];
              return (
                <div key={key} className={style.filter}>
                  <div className={style.label}>{components[key].label}</div>
                  <div className={style.item}>
                    {Cmp ? <Cmp
                      key={field.label}
                      id={field.label}
                      value={this.state.ids[key]}
                      required={field.required}
                      onChange={v => this.setState({ ids: { ...this.state.ids, [key]: v } })}
                    /> : `Unknown field type "${field.type}"`
                    }
                  </div>
                </div>
              );
            })}
          </div>
          <Button label="Find" primary raised type="submit" />
        </form>
        {this.state.results.map(id => this.renderTransaction(id))}
        {this.state.loading && <Spinner className={style.spinner} />}
        {this.state.results.length === 0 && !this.state.loading && <div>No results found</div>}
        {!this.state.loading && this.state.more && <Button
          label="Load more"
          disabled={this.state.loading}
          primary
          raised
          onClick={() => this.loadMore()}
          className={style.buttonLoadMore}
        />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.getIn(['transactions', 'items']).toJS(),
});

export default connect(mapStateToProps)(Transactions);



// WEBPACK FOOTER //
// ./app/pages/Transactions/index.js